import React, { useMemo } from "react";
import { Flex, HeaderText } from "@fanduel/formation-react-components";
import { COLORS, SPACING } from "@fanduel/formation-theming";

import Slot from "@urp/promos-page/components/Slot";

import type { CardSlot } from "../../types/Component";
import cardUtils from "../../utils/cardSlotUtils";

type Content = {
  header: string;
  slots: CardSlot[];
};

type Props = {
  content: Content;
};

/* eslint-disable no-underscore-dangle */

const PromoSlots: React.FC<Props> = ({ content }) => {
  const { slots: contentSlots } = content;

  const tabletLastRowIndex = useMemo(
    () => cardUtils.detectCardsLastRow(contentSlots.length, 2),
    [contentSlots.length]
  );
  const desktopLastRowIndex = useMemo(
    () => cardUtils.detectCardsLastRow(contentSlots.length, 3),
    [contentSlots.length]
  );

  const slots = useMemo(
    () =>
      contentSlots.map((slot, index) => (
        <Slot
          key={slot._uid}
          isTopPromo
          content={slot}
          position={index + 1}
          className={`
            ${index > tabletLastRowIndex ? "tabletLastRow" : ""}
            ${index > desktopLastRowIndex ? "desktopLastRow" : ""}
          `}
        />
      )),
    [contentSlots, tabletLastRowIndex, desktopLastRowIndex]
  );

  return (
    <Flex direction="column" gap={SPACING.space3} p={SPACING.space4}>
      <HeaderText
        data-qa-label="promo-title"
        size="md"
        color={COLORS.contentStrong}
      >
        {content.header}
      </HeaderText>
      <Flex
        data-qa-label="promoSlotsContainer"
        wrap
        justify="start"
        width="100%"
      >
        {slots}
      </Flex>
    </Flex>
  );
};

export default PromoSlots;
